package com.vamvisions.main.portfolio.data.remote

import com.vamvisions.main.api.ApiRoutes
import com.vamvisions.main.api.portfolio.DocumentDto
import com.vamvisions.main.api.portfolio.ExperienceListResponseDto
import com.vamvisions.main.api.portfolio.ProjectListResponseDto
import com.vamvisions.main.core.data.network.safeCall
import com.vamvisions.main.core.domain.DataError
import com.vamvisions.main.core.domain.Result
import com.vamvisions.main.core.domain.preferences.Language
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.request.parameter

/** The portfolio endpoints of the server API. Texts come back in the requested [Language]. */
class PortfolioApi(private val httpClient: HttpClient) {

    suspend fun getProjects(language: Language): Result<ProjectListResponseDto, DataError.Network> =
        safeCall {
            httpClient.get(ApiRoutes.Portfolio.PROJECTS) { parameter(LANG, language.code) }
        }

    suspend fun getExperiences(language: Language): Result<ExperienceListResponseDto, DataError.Network> =
        safeCall {
            httpClient.get(ApiRoutes.Portfolio.EXPERIENCES) { parameter(LANG, language.code) }
        }

    suspend fun getDocument(slug: String, language: Language): Result<DocumentDto, DataError.Network> =
        safeCall {
            httpClient.get(ApiRoutes.Portfolio.document(slug)) { parameter(LANG, language.code) }
        }

    private companion object {
        const val LANG = "lang"
    }
}
